module.exports = __webpack_public_path__ + "static/media/header_account.2a78e9d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_account.jpg
// module id = 1035
// module chunks = 0